import { HttpMethod } from "../Common/useFetch";
import { RequestOptions } from "../Common/useRequest";
import useUserRequest from "../Common/useUserRequest";
import { useSelectedBusiness } from "../UserAccess/useSelectedBusiness";

export interface AcceptDataSharingConnectionDto {
  acceptingSiteId: string;
}

const useAcceptConnection = (code: string, options?: RequestOptions<void>) => {
  const business = useSelectedBusiness();
  return useUserRequest<AcceptDataSharingConnectionDto, void>({
    path: `/api/businesses/${business.id}/dataSharing/codes/${code}/accept`,
    method: HttpMethod.POST,
  }, options);
};

export default useAcceptConnection;